import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useCookies } from 'react-cookie';

// 스타일 컴포넌트 정의
const Styled = {
  Wrap: styled.div`
    width: 100%;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    background-color: #ffffff;
    z-index: 3;
    position:auto;
  `,
  FixedWrap: styled.div`
    width: 100%;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    background-color: #ffffff;
    position: fixed;
    top: 90px;
    z-index: 3;
  `,
  AnchorWrap: styled.div`
    width: 88.8%;
    height: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;

    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  `,
  AnchorBox: styled.div`
    width: auto;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    border-radius: 17px;
    margin-right: 7px;
    padding: 0px 18px 0px 18px;
    border: 1px solid ${(props) => (props.selected ? "#2277F6" : "#B5B5B5")};;
    background-color: ${(props) => (props.selected ? "#2277F6" : "transparent")};
  `,
  AnchorText: styled.p`
    font-size: 14px;
    margin: 0px;
    font-family: 'PreFont';
    font-weight: 400;
    color: ${(props) => (props.selected ? "#ffffff" : "#B5B5B5")};
  `,
};

const NewAnchor = (props) => {
  const { CateGori, RestaurantInfo, isScrolled } = props;
  // isScrolled true면 스크롤 된거임. 헤더가 붙어야함.
  const [isFixed, setIsFixed] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const anchorRefs = useRef({});
  const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);

  const menuItems = RestaurantInfo.categories.map(item => item.names[Langcookies["PageLang"]]);

  useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.scrollY >= 60);

      const headerOffset = isFixed ? 60 : 190;
      let closestSection = null;
      let closestOffset = Infinity;

      RestaurantInfo.categories.forEach(category => {
        const id = category.names[Langcookies["PageLang"]];
        const el = document.getElementById(id);
        if (el) {
          const distance = Math.abs(el.getBoundingClientRect().top - headerOffset);
          if (distance < closestOffset) {
            closestOffset = distance;
            closestSection = id;
          }
        }
      });

      if (closestSection) {
        setActiveSection(closestSection);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFixed, RestaurantInfo.categories]);

  useEffect(()=>{
    console.log(isFixed)
  }, [isFixed])

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = isFixed ? 150 : 150;
      const offset = element.offsetTop - headerHeight;
      window.scrollTo({ top: offset, behavior: "smooth" });
      // setActiveSection(id); // 클릭 시에도 선택 반영
    }
  };

  useEffect(() => {
    if (activeSection && anchorRefs.current[activeSection]) {
      anchorRefs.current[activeSection].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeSection]);

  if(isFixed === true){
    return(
      <Styled.FixedWrap>
        <Styled.AnchorWrap>
          {menuItems.map((item, index) => (
            <Styled.AnchorBox
              key={index}
              ref={(el) => (anchorRefs.current[item] = el)}
              selected={activeSection === item}
              onClick={() => scrollToSection(item)}
            >
              <Styled.AnchorText selected={activeSection === item}>
                {item}
              </Styled.AnchorText>
            </Styled.AnchorBox>
          ))}
        </Styled.AnchorWrap>
      </Styled.FixedWrap>
    )

  }else{
    return (
      <Styled.Wrap>
        <Styled.AnchorWrap>
          {menuItems.map((item, index) => (
            <Styled.AnchorBox
              key={index}
              ref={(el) => (anchorRefs.current[item] = el)}
              selected={activeSection === item}
              onClick={() => scrollToSection(item)}
            >
              <Styled.AnchorText selected={activeSection === item}>
                {item}
              </Styled.AnchorText>
            </Styled.AnchorBox>
          ))}
        </Styled.AnchorWrap>
      </Styled.Wrap>
    );
  }

};

export default NewAnchor;
